// extracted by mini-css-extract-plugin
export default {"separator":"_1vk9yi8dPySREJQHlk_BhQ"};